import { TextField, IconButton } from '@material-ui/core';
import { useStyles } from '../../styles';
import { Controller, useWatch } from "react-hook-form";
import ReactHookTextField from 'components/ReactHookTextField';
import NumberFormat from 'components/NumberFormat';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';

const Row = ({ editable, fieldData, control, index, setTotalPrice, totalPrice, append, remove }) => {
    const classes = useStyles();

    const qty = useWatch({
        control,
        name: `lineItems.${index}.quantity`
    }, false);

    const price = useWatch({
        control,
        name: `lineItems.${index}.price`
    }, false);

    // console.log(totalPrice)
    return editable ? (
        <div style={{display: 'flex'}}>
            <ReactHookTextField
                name={`lineItems.${index}.description`}
                type='textarea'
                control={control}
                label='Description'
                style={{flex: 'auto', marginRight: '10px'}}
                InputProps={{
                    multiline:true
                }}
            />

            <Controller
                name={`lineItems.${index}.quantity`}
                type='number'
                control={control}
                render={({ field, fieldState: { error } }) => <TextField 
                    {...field} 
                    label='Qty'
                    style={{minWidth: '70px', marginRight: '10px'}}
                    className={classes.input}
                    variant='outlined' 
                    InputLabelProps={{ shrink: true }} 
                    size='small'
                    error={error}
                    helperText={error && error.message} 
                    onChange={(e) => {
                        const quantity = e.target.value;

                        setTotalPrice([
                            ...totalPrice.slice(0,index),
                            quantity * (price || 0),
                            ...totalPrice.slice(index+1)
                        ]);

                        field.onChange(quantity);
                        }}
                    />
                }
            />     

            <Controller
                name={`lineItems.${index}.price`}
                type='number'
                control={control}
                render={({ field, fieldState: { error } }) => <TextField 
                    {...field} 
                    label='Item Price'
                    style={{width: '175px', marginRight: '10px'}}
                    className={classes.input}
                    variant='outlined' 
                    InputLabelProps={{ shrink: true }} 
                    size='small'
                    error={error}
                    helperText={error && error.message} 
                    onChange={(e) => {
                        const price = e.target.value;
                        setTotalPrice([
                            ...totalPrice.slice(0,index),
                            (qty || 0) * price,
                            ...totalPrice.slice(index+1)
                        ]);
                        field.onChange(price);
                        }}
                    InputProps={{
                        inputComponent: NumberFormat,
                    }}
                    />
                }
            />     

            <TextField
                label='Total Price'
                type='text'
                disabled={true}
                className={classes.input}
                variant='outlined' 
                InputLabelProps={{ shrink: true }} 
                size='small'
                value={price * qty}
                style={{width: '175px', marginRight: '10px'}}
                InputProps={{
                    inputComponent: NumberFormat,
                }}
            />

            <div style={{textAlign: 'right'}}>
                <IconButton
                    type="button"
                    color="secondary"
                    onClick={() => {
                        setTotalPrice([
                            ...totalPrice.slice(0,index),
                            ...totalPrice.slice(index+1)
                        ]);
                        return remove(index);
                    }}
                    style={{width: '20px'}}
                    >
                    <RemoveIcon />
                </IconButton>
                
                <IconButton
                    type="button"
                    color="secondary"
                    onClick={() => append({})}
                    style={{width: '20px'}}
                    >
                    <AddIcon />
                </IconButton>
            </div>
        </div>                
    ) : (
        <div style={{display: 'flex'}}>

            <TextField
                label='Description'
                type='textarea'
                disabled={true}
                className={classes.input}
                variant='outlined'
                InputLabelProps={{ shrink: true }}
                size='small'
                value={fieldData.description}
                style={{flex: 'auto', marginRight: '10px'}}
            />

            <TextField
                label='Qty'
                type='text'
                disabled={true}
                className={classes.input}
                variant='outlined'
                InputLabelProps={{ shrink: true }}
                size='small'
                value={fieldData.quantity}
                style={{minWidth: '70px', marginRight: '10px'}}
            />


            <TextField
                label='Item Price'
                type='text'
                disabled={true}
                className={classes.input}
                variant='outlined'
                InputLabelProps={{ shrink: true }}
                size='small'
                value={fieldData.price}
                style={{width: '175px', marginRight: '10px'}}
                InputProps={{
                    inputComponent: NumberFormat,
                }}
            />

            <TextField
                label='Total Price'
                type='text'
                disabled={true}
                className={classes.input}
                variant='outlined' 
                InputLabelProps={{ shrink: true }} 
                size='small'
                value={price * qty}
                style={{width: '175px', marginRight: '60px'}}
                InputProps={{
                    inputComponent: NumberFormat,
                }}
            />
        </div>  
    );
};

export default Row;
